import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createSpeed = ( {data} : {data: IPostNewSpeed | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/Speeds/InsertSpeed`, data);
};

type QueryFnType = typeof createSpeed;

type UseCreateSpeedOptions = {
  data: IPostNewSpeed | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateSpeed = ({ config }: UseCreateSpeedOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Ταχύτητας Γραμμής.`, 500);
            console.error('Couldnt create new Speed', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllSpeeds"])
            addNotification("Δημιουργήθηκε Νέα Ταχύτητα Γραμμής.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createSpeed,
    })
}